module.exports = {
  entry: './src/apps/storage-protect-calculator/index.tsx',
  shortcode: 'storage-protect-calculator',
  title: 'Storage Protect Estimator',
  status: 'stable',
  description: 'Allows users to determine a price.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-storage-protect-calculator-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'id',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
